/* Skeleton utility file */
const SHIMMER_BAND_WIDTH_PX = 280;
const SHIMMER_VIEWPORT_DURATION_MS = 3000;
const WIDTHS = [100, 62, 90, 68, 81, 75, 95, 60, 72, 85, 65, 78, 88, 92, 70, 82];
const LAST_LINE_MIN = 35;
const LAST_LINE_RANGE = 20;
function lineWidth(index, seed, lineCount) {
    if (lineCount > 1 && index === lineCount - 1) {
        return `${LAST_LINE_MIN + (seed % LAST_LINE_RANGE)}%`;
    }
    const hash = Math.imul(seed ^ index, 0x9e3779b1) >>> 0; // Knuth multiplicative hash (2^32 / φ)
    return `${WIDTHS[hash % WIDTHS.length]}%`;
}
function seedFromId(id) {
    let h = 0;
    for (let i = 0; i < id.length; ++i) {
        h = (h * 31 + id.charCodeAt(i)) | 0;
    }
    return Math.abs(h);
}

export { SHIMMER_BAND_WIDTH_PX, SHIMMER_VIEWPORT_DURATION_MS, lineWidth, seedFromId };
//# sourceMappingURL=skeleton.utils.js.map
